import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = runtimeEnv("B2B_API_BASE_URL");

//Company Profile
export const fetchCompanyProfile = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Company.api + "/" + data}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Parent Company
export const fetchParentCompanyList = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Company.api}?type=parent`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const fetchCompanyLogoDetails = async (companyId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Company.companyLogo}/${companyId}`)
    .catch((err) => err.response);

  return setCurrentUser(res);
};
